import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  }).format(date);
}

export const moodLabels = [
  { value: 1, label: "Difficult", icon: "frown" },
  { value: 2, label: "Mixed", icon: "meh" },
  { value: 3, label: "Neutral", icon: "meh" },
  { value: 4, label: "Hopeful", icon: "smile" },
  { value: 5, label: "Strong", icon: "smile" }
];

export const fatigueLabels = [
  { value: 1, label: "Exhausted", icon: "x-circle" },
  { value: 2, label: "Tired", icon: "moon" },
  { value: 3, label: "Average", icon: "clock" },
  { value: 4, label: "Focused", icon: "coffee" },
  { value: 5, label: "Energetic", icon: "zap" }
];

export const dailyTasks = [
  {
    id: 1,
    title: "5-minute gentle stretch",
    description: "Supports your body's recovery"
  },
  {
    id: 2,
    title: "Write down one positive moment",
    description: "Helps build resilience"
  },
  {
    id: 3,
    title: "3-minute mindful breathing",
    description: "Reduces stress hormones"
  }
];

export const getFirstName = (fullName: string): string => {
  if (!fullName) return "";
  return fullName.split(" ")[0];
};

// Delete all caches to force reload of all assets (e.g. for Dark Mode switch)
export async function clearCaches() {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    for (const name of cacheNames) {
      await caches.delete(name);
    }
  }
}

// Clears all caches, localStorage, sessionStorage, and unregisters service workers, then reloads to /auth
export async function clearAllCachesAndReload(
  clearLocalStorage: boolean = false,
  clearSessionStorage: boolean = false
) {
  if (clearLocalStorage) {
    window.localStorage.clear();
  }
  
  if (clearSessionStorage) {
    window.sessionStorage.clear();
  }

  // Call the function to clear caches implemented above
  await clearCaches();

  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
  }
  
  const authPath = `/auth?v=${Date.now()}`;
  window.location.href = authPath;
}

// Convert Blob to base64 string (for Capacitor Filesystem)
export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
